import { useContext } from 'react';
import { Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SttButton } from '../sporttia/all';
import coffeeImage from '../images/coffee.svg';
import { AppContext } from '../sporttia/AppContext';
import { getLandingPath } from '../config/routePermissions';

export default function Page401(): React.ReactElement {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const cxt = useContext(AppContext)!;

    // El cuadrante, o con los roles encendidos y sin booking.view la primera
    // sección que el operador puede abrir (si no, su cuenta): volver al
    // cuadrante sin permiso mandaría a otra 401.
    const landingPath = getLandingPath({
        rolesEnabled: !!cxt?.rolesEnabled,
        permissions: cxt?.permissions ?? [],
        privileges: cxt?.privileges ?? [],
    });

    return (
        <Box m={8} sx={{ textAlign: 'center' }}>
            <img src={coffeeImage} width={230} alt="401" />

            <h1>{t('page401.title')}</h1>
            <p style={{ color: '#888' }}>{t('page401.message')}</p>
            <Box mt={5}>
                <SttButton
                    caption={t('BackIndexPage')}
                    icon={<HomeIcon />}
                    onClick={() => navigate(landingPath)}
                />
            </Box>
        </Box>
    );
}
